// Liste des villes françaises triées par population (décroissant)
// Source: INSEE - Communes de France
export const FRENCH_CITIES: string[] = [
    "Paris",
    "Marseille",
    "Lyon",
    "Toulouse",
    "Nice",
    "Nantes",
    "Montpellier",
    "Strasbourg",
    "Bordeaux",
    "Lille",
    "Rennes",
    "Reims",
    "Le Havre",
    "Saint-Étienne",
    "Toulon",
    "Grenoble",
    "Dijon",
    "Angers",
    "Nîmes",
    "Villeurbanne",
    "Le Mans",
    "Aix-en-Provence",
    "Brest",
    "Tours",
    "Amiens",
    "Limoges",
    "Annecy",
    "Perpignan",
    "Boulogne-Billancourt",
    "Metz",
    "Besançon",
    "Orléans",
    "Argenteuil",
    "Saint-Denis",
    "Rouen",
    "Montreuil",
    "Caen",
    "Mulhouse",
    "Nancy",
    "Roubaix",
    "Tourcoing",
    "Nanterre",
    "Avignon",
    "Vitry-sur-Seine",
    "Créteil",
    "Dunkerque",
    "Poitiers",
    "Asnieres-sur-Seine",
    "Courbevoie",
    "Versailles",
    "Colombes",
    "Fort-de-France",
    "Aulnay-sous-Bois",
    "Rueil-Malmaison",
    "Pau",
    "Champigny-sur-Marne",
    "Antibes",
    "Saint-Maur-des-Fossés",
    "Béziers",
    "Cannes",
    "Calais",
    "Clermont-Ferrand",
    "La Rochelle",
    "Mérignac",
    "Saint-Nazaire",
    "Aix-les-Bains",
    "Drancy",
    "Colmar",
    "Noisy-le-Grand",
    "Bourges",
    "Issy-les-Moulineaux",
    "Levallois-Perret",
    "La Seyne-sur-Mer",
    "Quimper",
    "Neuilly-sur-Seine",
    "Villeneuve-d'Ascq",
    "Valence",
    "Ivry-sur-Seine",
    "Cergy",
    "Pessac",
    "Troyes",
    "Antony",
    "Montauban",
    "Pantin",
    "Lorient",
    "Évry-Courcouronnes",
    "Chambéry",
    "Vénissieux",
    "Niort",
    "La Courneuve",
    "Clichy",
    "Saint-Quentin",
    "Montrouge",
    "Meaux",
    "Cherbourg-en-Cotentin",
    "Aubagne",
    "Boulogne-sur-Mer",
    "Bayonne",
    "Massy",
    "Épinay-sur-Seine",
    "Villejuif",
    "Fontenay-sous-Bois",
    "Belfort",
    "Saint-Denis (Réunion)",
    "Alençon",
    "Caluire-et-Cuire",
    "Laval",
    "Sarcelles",
    "Évreux",
    "Ajaccio",
    "Nîmes",
    "Le Tampon",
    "Brive-la-Gaillarde",
    "Saint-Pierre (Réunion)",
    "Cholet",
    "Nîmes",
    "Chalon-sur-Saône",
    "Clamart",
    "Valenciennes",
    "Mantes-la-Jolie",
    "Maisons-Alfort",
    "Besançon",
    "Bagneux",
    "Melun",
    "Hyères",
    "Argenteuil",
    "Vannes",
    "Sartrouville",
    "Noisy-le-Sec",
    "Rosny-sous-Bois",
    "Bobigny",
    "Creil",
    "Caen",
    "Gennevilliers",
    "Corbeil-Essonnes",
    "Chelles",
    "Le Blanc-Mesnil",
    "Cagnes-sur-Mer",
    "Auxerre",
    "Arles",
    "Wattrelos",
    "Bastia",
    "Suresnes",
    "Salon-de-Provence",
    "Saint-Herblain",
    "Vitrolles",
    "Charleville-Mézières",
    "Épinay-sous-Sénart",
    "Pessac",
    "Villepinte",
    "Puteaux",
    "Quimper",
    "Annemasse",
    "Thionville",
    "Arras",
    "Chartres",
    "Saint-Ouen",
    "Blois",
    "Narbonne",
    "La Roche-sur-Yon",
    "Bondy",
    "Gagny",
    "Angoulême",
    "Le Cannet",
    "Argentan",
    "Draguignan",
    "Grasse",
    "Pontoise",
    "Châteauroux",
    "Colomiers",
    "Rezé",
    "Istres",
    "Montélimar",
    "Martigues",
    "Châtenay-Malabry",
    "Boulogne-sur-Mer",
    "Lens",
    "Albi",
    "Douai",
    "Liévin",
    "Hénin-Beaumont",
    "Maubeuge",
    "Bron",
    "Vaulx-en-Velin",
    "Rillieux-la-Pape",
    "Décines-Charpieu",
    "Meyzieu",
    "Givors",
    "Feyzin",
    "Oullins",
    "Saint-Priest",
    "Gières",
    "Échirolles",
    "Fontaine",
    "Cran-Gevrier",
    "Seynod",
    "Annecy-le-Vieux",
    "Archamps",
    "Ambilly",
    "Annemasse",
    "Gaillard",
    "Thonon-les-Bains",
    "Évian-les-Bains",
    "Albertville",
    "Chambéry",
    "Bourg-en-Bresse",
    "Oyonnax",
    "Ambérieu-en-Bugey",
    "Belley",
    "Romans-sur-Isère",
    "Valence",
    "Montélimar",
    "Pierrelatte",
    "Nîmes",
    "Alès",
    "Uzès",
    "Bagnols-sur-Cèze",
    "Pont-Saint-Esprit",
    "Beaucaire",
    "Tarascon",
    "Arles",
    "Martigues",
    "Port-de-Bouc",
    "Fos-sur-Mer",
    "Miramas",
    "Istres",
    "Marignane",
    "Vitrolles",
    "Aix-en-Provence",
    "Gardanne",
    "Trets",
    "Aubagne",
    "La Ciotat",
    "Cassis",
    "Marseille",
    "Septèmes-les-Vallons",
    "Les Pennes-Mirabeau",
    "Allauch",
    "Plan-de-Cuques",
    "Château-Gombert",
    "Toulon",
    "La Seyne-sur-Mer",
    "Six-Fours-les-Plages",
    "Sanary-sur-Mer",
    "Bandol",
    "Hyères",
    "Sainte-Maxime",
    "Saint-Tropez",
    "Fréjus",
    "Saint-Raphaël",
    "Cannes",
    "Mougins",
    "Grasse",
    "Cagnes-sur-Mer",
    "Nice",
    "Monaco",
    "Menton",
    "Beausoleil",
    "Roquebrune-Cap-Martin",
    "Cap-d'Ail",
    "Èze",
    "Villefranche-sur-Mer",
    "Beaulieu-sur-Mer",
    "Saint-Jean-Cap-Ferrat",
    "Antibes",
    "Juan-les-Pins",
    "Sophia Antipolis",
    "Valbonne",
    "Vallauris",
    "Golfe-Juan",
    "La Napoule",
    "Mandelieu-la-Napoule",
    "Théoule-sur-Mer",
    "Menton",
    "Sospel",
    "Breil-sur-Roya",
    "Tende",
    "Montpellier",
    "Palavas-les-Flots",
    "Lattes",
    "Pérols",
    "Mauguio",
    "Castelnau-le-Lez",
    "Clapiers",
    "Grabels",
    "Juvignac",
    "Murviel-lès-Montpellier",
    "Saint-Jean-de-Védas",
    "Sète",
    "Frontignan",
    "Vic-la-Gardiole",
    "Mireval",
    "Gigean",
    "Béziers",
    "Agde",
    "Cap d'Agde",
    "Pézenas",
    "Clermont-l'Hérault",
    "Lodève",
    "Millau",
    "Rodez",
    "Figeac",
    "Cahors",
    "Agen",
    "Mont-de-Marsan",
    "Dax",
    "Bayonne",
    "Anglet",
    "Biarritz",
    "Hendaye",
    "Saint-Jean-de-Luz",
    "Bidart",
    "Guéthary",
    "Arbonne",
    "Mouguerre",
    "Ustaritz",
    "Cambo-les-Bains",
    "Espelette",
    "Pau",
    "Tarbes",
    "Lourdes",
    "Bagnères-de-Bigorre",
    "Lannemezan",
    "Saint-Gaudens",
    "Muret",
    "Toulouse",
    "Blagnac",
    "Colomiers",
    "Tournefeuille",
    "Plaisance-du-Touch",
    "L'Union",
    "Balma",
    "Labège",
    "Castanet-Tolosan",
    "Ramonville-Saint-Agne",
    "Portet-sur-Garonne",
    "Cugnaux",
    "Villeneuve-Tolosane",
    "Roques",
    "Léguevin",
    "Pibrac",
    "Aussonne",
    "Launaguet",
    "Quint-Fonsegrives",
    "Aucamville",
    "Lanta",
    "Escalquens",
    "Flourens",
    "Drémil-Lafage",
    "Montrabé",
    "Verfeil",
    "Caraman",
    "Revel",
    "Castres",
    "Mazamet",
    "Gaillac",
    "Albi",
    "Carmaux",
    "Castelsarrasin",
    "Moissac",
    "Montauban",
    "Verdun-sur-Garonne",
    "Grisolles",
    "Fronton",
    "Grenade",
    "Bessières",
    "Villemur-sur-Tarn",
    "L'Isle-Jourdain",
    "Auch",
    "Condom",
    "Fleurance",
    "Lectoure",
    "Aire-sur-l'Adour",
    "Marmande",
    "Tonneins",
    "Villeneuve-sur-Lot",
    "Fumel",
    "Périgueux",
    "Bergerac",
    "Sarlat-la-Canéda",
    "Brive-la-Gaillarde",
    "Tulle",
    "Ussel",
    "Guéret",
    "Limoges",
    "Saint-Junien",
    "Rochechouart",
    "Angoulême",
    "Cognac",
    "Saintes",
    "Royan",
    "La Rochelle",
    "Rochefort",
    "Niort",
    "Poitiers",
    "Châtellerault",
    "Parthenay",
    "Bressuire",
    "Thouars",
    "Cholet",
    "Saumur",
    "Angers",
    "Le Mans",
    "Laval",
    "Mayenne",
    "Flers",
    "Argentan",
    "Alençon",
    "Caen",
    "Bayeux",
    "Lisieux",
    "Vire",
    "Avranches",
    "Saint-Lô",
    "Cherbourg-en-Cotentin",
    "Granville",
    "Coutances",
    "Cherbourg",
    "Valognes",
    "Saint-Malo",
    "Dinard",
    "Dinan",
    "Vannes",
    "Lorient",
    "Quimper",
    "Brest",
    "Morlaix",
    "Lannion",
    "Saint-Brieuc",
    "Guingamp",
    "Pontivy",
    "Auray",
    "Carnac",
    "Quiberon",
    "Belle-Île",
    "Rennes",
    "Vitré",
    "Fougères",
    "Saint-Malo",
    "Cancale",
    "Mont-Saint-Michel",
    "Avranches",
    "Nantes",
    "Saint-Nazaire",
    "La Baule-Escoublac",
    "Pornichet",
    "Pornic",
    "Noirmoutier-en-l'Île",
    "Les Sables-d'Olonne",
    "Fontenay-le-Comte",
    "Luçon",
    "La Roche-sur-Yon",
    "Les Herbiers",
    "Montaigu",
    "Clisson",
    "Ancenis",
    "Châteaubriant",
    "Redon",
    "Rennes",
    "Cesson-Sévigné",
    "Bruz",
    "Chantepie",
    "Saint-Jacques-de-la-Lande",
    "Pacé",
    "Betton",
    "Acigné",
    "Noyal-Châtillon-sur-Seiche",
    "Vezin-le-Coquet",
    "L'Hermitage",
    "Brest",
    "Guipavas",
    "Le Relecq-Kerhuon",
    "Plouzané",
    "Gouesnou",
    "Plougastel-Daoulas",
    "Landerneau",
    "Quimperlé",
    "Concarneau",
    "Fouesnant",
    "Bénodet",
    "Pont-l'Abbé",
    "Douarnenez",
    "Châteaulin",
    "Carhaix-Plouguer",
    "Huelgoat",
    "Bordeaux",
    "Mérignac",
    "Pessac",
    "Talence",
    "Gradignan",
    "Villenave-d'Ornon",
    "Bègles",
    "Floirac",
    "Cenon",
    "Lormont",
    "Bassens",
    "Ambès",
    "Carbon-Blanc",
    "Sainte-Eulalie",
    "Bruges",
    "Le Bouscat",
    "Caudéran",
    "Eysines",
    "Le Haillan",
    "Mérignac",
    "Saint-Médard-en-Jalles",
    "Blanquefort",
    "Ludon-Médoc",
    "Margaux",
    "Pauillac",
    "Lesparre-Médoc",
    "Arcachon",
    "Gujan-Mestras",
    "La Teste-de-Buch",
    "Andernos-les-Bains",
    "Lanton",
    "Audenge",
    "Biganos",
    "Mios",
    "Salles",
    "Belin-Béliet",
    "Bazas",
    "Langon",
    "La Réole",
    "Libourne",
    "Fronsac",
    "Pomerol",
    "Saint-Émilion",
    "Castillon-la-Bataille",
    "Bergerac",
    "Strasbourg",
    "Schiltigheim",
    "Bischheim",
    "Hoenheim",
    "Reichstett",
    "La Wantzenau",
    "Mundolsheim",
    "Lampertheim",
    "Vendenheim",
    "Truchtersheim",
    "Brumath",
    "Haguenau",
    "Wissembourg",
    "Saverne",
    "Sélestat",
    "Obernai",
    "Molsheim",
    "Benfeld",
    "Erstein",
    "Ostwald",
    "Illkirch-Graffenstaden",
    "Lingolsheim",
    "Eckbolsheim",
    "Colmar",
    "Mulhouse",
    "Huningue",
    "Saint-Louis",
    "Hésingue",
    "Blotzheim",
    "Rixheim",
    "Riedisheim",
    "Wittenheim",
    "Sausheim",
    "Illzach",
    "Kingersheim",
    "Wittelsheim",
    "Cernay",
    "Thann",
    "Guebwiller",
    "Munster",
    "Turckheim",
    "Wintzenheim",
    "Rouffach",
    "Ensisheim",
    "Metz",
    "Woippy",
    "Montigny-lès-Metz",
    "Longeville-lès-Metz",
    "Saint-Julien-lès-Metz",
    "Augny",
    "Chesny",
    "Vany",
    "Plappeville",
    "Lorry-lès-Metz",
    "Thionville",
    "Yutz",
    "Uckange",
    "Algrange",
    "Hayange",
    "Florange",
    "Gandrange",
    "Rombas",
    "Maizières-lès-Metz",
    "Amnéville",
    "Forbach",
    "Sarrebourg",
    "Sarreguemines",
    "Saint-Avold",
    "Stiring-Wendel",
    "Freyming-Merlebach",
    "L'Hôpital",
    "Creutzwald",
    "Carling",
    "Behren-lès-Forbach",
    "Nancy",
    "Vandœuvre-lès-Nancy",
    "Laxou",
    "Maxéville",
    "Jarville-la-Malgrange",
    "Essey-lès-Nancy",
    "Pulnoy",
    "Seichamps",
    "Dombasle-sur-Meurthe",
    "Lunéville",
    "Toul",
    "Pont-à-Mousson",
    "Dieulouard",
    "Frouard",
    "Custines",
    "Liverdun",
    "Bar-le-Duc",
    "Verdun",
    "Épinal",
    "Remiremont",
    "Saint-Dié-des-Vosges",
    "Gérardmer",
    "Besançon",
    "Montbéliard",
    "Sochaux",
    "Audincourt",
    "Valentigney",
    "Bethoncourt",
    "Exincourt",
    "Pont-de-Roide-Vermondans",
    "Baume-les-Dames",
    "Héricourt",
    "Luxeuil-les-Bains",
    "Vesoul",
    "Gray",
    "Lure",
    "Pontarlier",
    "Morteau",
    "Maîche",
    "Belfort",
    "Delle",
    "Offemont",
    "Danjoutin",
    "Bavilliers",
    "Dijon",
    "Chenôve",
    "Longvic",
    "Marsannay-la-Côte",
    "Talant",
    "Fontaine-lès-Dijon",
    "Plombières-lès-Dijon",
    "Chevigny-Saint-Sauveur",
    "Quetigny",
    "Saint-Apollinaire",
    "Ahuy",
    "Sennecey-lès-Dijon",
    "Beaune",
    "Nuits-Saint-Georges",
    "Gevrey-Chambertin",
    "Vougeot",
    "Meursault",
    "Chalon-sur-Saône",
    "Le Creusot",
    "Montceau-les-Mines",
    "Gueugnon",
    "Paray-le-Monial",
    "Mâcon",
    "Tournus",
    "Cluny",
    "Charlieu",
    "Roanne",
    "Thiers",
    "Vichy",
    "Moulins",
    "Montluçon",
    "Clermont-Ferrand",
    "Riom",
    "Issoire",
    "Ambert",
    "Aurillac",
    "Le Puy-en-Velay",
    "Brioude",
    "Yssingeaux",
    "Annonay",
    "Privas",
    "Aubenas",
    "Largentière",
    "Vals-les-Bains",
    "Montélimar",
    "Romans-sur-Isère",
    "Valence",
    "Bourg-lès-Valence",
    "Guilherand-Granges",
    "Portes-lès-Valence",
    "Crest",
    "Die",
    "Nyons",
    "Grenoble",
    "Échirolles",
    "Fontaine",
    "Saint-Martin-d'Hères",
    "Meylan",
    "Gières",
    "Seyssinet-Pariset",
    "Pont-de-Claix",
    "Voiron",
    "Bourgoin-Jallieu",
    "La Tour-du-Pin",
    "Vienne",
    "Roussillon",
    "Givors",
    "Genas",
    "Villefontaine",
    "Ruy-Montclar",
    "Saint-Quentin-Fallavier",
    "Heyrieux",
    "Pont-Évêque",
    "Chonas-l'Amballan",
    "Condrieu",
    "Amiens",
    "Longueau",
    "Rivery",
    "Boves",
    "Camon",
    "Abbeville",
    "Péronne",
    "Albert",
    "Montdidier",
    "Compiègne",
    "Noyon",
    "Creil",
    "Senlis",
    "Soissons",
    "Laon",
    "Saint-Quentin",
    "Vervins",
    "Hirson",
    "Château-Thierry",
    "Épernay",
    "Reims",
    "Troyes",
    "Sens",
    "Auxerre",
    "Avallon",
    "Vézelay",
    "Nevers",
    "Decize",
    "Cosne-Cours-sur-Loire",
    "Bourges",
    "Vierzon",
    "Saint-Amand-Montrond",
    "Châteauroux",
    "Issoudun",
    "Tours",
    "Amboise",
    "Blois",
    "Vendôme",
    "Loir-et-Cher",
    "Orléans",
    "Fleury-les-Aubrais",
    "Olivet",
    "Saint-Jean-de-Braye",
    "Saint-Cyr-en-Val",
    "La Source",
    "Châteauneuf-sur-Loire",
    "Gien",
    "Montargis",
    "Pithiviers",
    "Dreux",
    "Chartres",
    "Nogent-le-Rotrou",
    "Châteaudun",
    "Vendôme",
    "Le Mans",
    "La Flèche",
    "Sablé-sur-Sarthe",
    "Mamers",
    "Paris",
    "Boulogne-Billancourt",
    "Argenteuil",
    "Montreuil",
    "Saint-Denis",
    "Créteil",
    "Vitry-sur-Seine",
    "Colombes",
    "Asnières-sur-Seine",
    "Courbevoie",
    "Nanterre",
    "Versailles",
    "Aulnay-sous-Bois",
    "Rueil-Malmaison",
    "Champigny-sur-Marne",
    "Saint-Maur-des-Fossés",
    "Drancy",
    "Noisy-le-Grand",
    "Issy-les-Moulineaux",
    "Levallois-Perret",
    "Ivry-sur-Seine",
    "Pantin",
    "Antony",
    "La Courneuve",
    "Clichy",
    "Montrouge",
    "Meaux",
    "Épinay-sur-Seine",
    "Villejuif",
    "Fontenay-sous-Bois",
    "Sarcelles",
    "Bagneux",
    "Melun",
    "Sartrouville",
    "Noisy-le-Sec",
    "Rosny-sous-Bois",
    "Bobigny",
    "Gennevilliers",
    "Corbeil-Essonnes",
    "Chelles",
    "Le Blanc-Mesnil",
    "Maisons-Alfort",
    "Massy",
    "Bondy",
    "Châtenay-Malabry",
    "Puteaux",
    "Villepinte",
    "Gagny",
    "Clamart",
    "Suresnes",
    "Évry-Courcouronnes",
    "Juvisy-sur-Orge",
    "Savigny-sur-Orge",
    "Massy",
    "Palaiseau",
    "Orsay",
    "Saclay",
    "Saint-Germain-en-Laye",
    "Poissy",
    "Conflans-Sainte-Honorine",
    "Trappes",
    "Guyancourt",
    "Vélizy-Villacoublay",
    "Jouy-en-Josas",
    "Buc",
    "Viroflay",
    "Chaville",
    "Meudon",
    "Bellevue",
    "Sèvres",
    "Saint-Cloud",
    "Garches",
    "Vaucresson",
    "Marnes-la-Coquette",
    "Ville-d'Avray",
    "Chaville",
    "Vanves",
    "Malakoff",
    "Châtillon",
    "Fontenay-aux-Roses",
    "Sceaux",
    "Bourg-la-Reine",
    "Fresnes",
    "Villejuif",
    "Rungis",
    "Thiais",
    "Chevilly-Larue",
    "L'Haÿ-les-Roses",
    "Cachan",
    "Arcueil",
    "Gentilly",
    "Le Kremlin-Bicêtre",
    "Charenton-le-Pont",
    "Saint-Mandé",
    "Vincennes",
    "Saint-Maurice",
    "Joinville-le-Pont",
    "Chennevières-sur-Marne",
    "Sucy-en-Brie",
    "Boissy-Saint-Léger",
    "Villecresnes",
    "Mandres-les-Roses",
    "Périgny",
    "Yerres",
    "Brunoy",
    "Épinay-sous-Sénart",
    "Montgeron",
    "Draveil",
    "Vigneux-sur-Seine",
    "Viry-Châtillon",
    "Grigny",
    "Ris-Orangis",
    "Courcouronnes",
    "Bondoufle",
    "Lisses",
    "Saint-Germain-lès-Arpajon",
    "Arpajon",
    "Brétigny-sur-Orge",
    "Étampes",
    "Dourdan",
    "Lardy",
    "Égly",
    "Leuville-sur-Orge",
    "Longpont-sur-Orge",
    "Montlhéry",
    "La Norville",
    "Saint-Yon",
    "Sermaise",
    "Chamarande",
    "Itteville",
    "Mennecy",
    "Ballancourt-sur-Essonne",
    "La Ferté-Alais",
    "Milly-la-Forêt",
    "Courcouronnes",
    "Sainte-Geneviève-des-Bois",
    "Fleury-Mérogis",
    "Breuillet",
    "Saint-Chéron",
    "Auvers-Saint-Georges",
    "Boissy-sous-Saint-Yon",
    "Les Ulis",
    "Gif-sur-Yvette",
    "Bures-sur-Yvette",
    "La Ville-du-Bois",
    "Nozay",
    "Villebon-sur-Yvette",
    "Marcoussis",
    "Montlhéry",
    "Linas",
    "Brétigny-sur-Orge",
    "Rouen",
    "Sotteville-lès-Rouen",
    "Saint-Étienne-du-Rouvray",
    "Le Grand-Quevilly",
    "Le Petit-Quevilly",
    "Maromme",
    "Mont-Saint-Aignan",
    "Bois-Guillaume",
    "Bihorel",
    "Déville-lès-Rouen",
    "Canteleu",
    "Petit-Couronne",
    "Grand-Couronne",
    "Elbeuf",
    "Caudebec-lès-Elbeuf",
    "Louviers",
    "Val-de-Reuil",
    "Évreux",
    "Vernon",
    "Gaillon",
    "Les Andelys",
    "Gisors",
    "Dieppe",
    "Saint-Valery-en-Caux",
    "Fécamp",
    "Le Havre",
    "Harfleur",
    "Montivilliers",
    "Gonfreville-l'Orcher",
    "Port-Jérôme-sur-Seine",
    "Bolbec",
    "Lillebonne",
    "Yvetot",
    "Barentin",
    "Clères",
    "Neufchâtel-en-Bray",
    "Forges-les-Eaux",
    "Buchy",
    "Lyons-la-Forêt",
    "Les Andelys",
    "Écos",
    "Gisors",
    "Chaumont",
    "Langres",
    "Bar-sur-Aube",
    "Troyes",
    "Romilly-sur-Seine",
    "Nogent-sur-Seine",
    "Provins",
    "Fontainebleau",
    "Nemours",
    "Montereau-Fault-Yonne",
    "Moret-Loing-et-Orvanne",
    "Chailly-en-Brie",
    "Tournan-en-Brie",
    "Rozay-en-Brie",
    "Provins",
    "Nangis",
    "Donnemarie-Dontilly",
    "Moret-Loing-et-Orvanne",
    "Sens",
    "Joigny",
    "Auxerre",
    "Tonnerre",
    "Chablis",
    "Avallon",
    "Vézelay",
    "Clamecy",
    "Cosne-Cours-sur-Loire",
    "La Charité-sur-Loire",
    "Nevers",
    "Fourchambault",
    "Varennes-Vauzelles",
    "Imphy",
    "Saint-Pierre-le-Moûtier",
    "Decize",
    "Moulins",
    "Vichy",
    "Cusset",
    "Bellerive-sur-Allier",
    "Gannat",
    "Saint-Pourçain-sur-Sioule",
    "Lapalisse",
    "Thiers",
    "Ambert",
    "Brioude",
    "Issoire",
    "Riom",
    "Aigueperse",
    "Pont-du-Château",
    "Cournon-d'Auvergne",
    "Aubière",
    "Chamalières",
    "Royat",
    "Orcines",
    "Ennezat",
    "Mozac",
    "Lezoux",
    "Saint-Dier-d'Auvergne",
    "Billom",
    "Vic-le-Comte",
    "Issoire",
    "Ardes",
    "Besse-et-Saint-Anastaise",
    "La Tour-d'Auvergne",
    "Bort-les-Orgues",
    "Riom-ès-Montagnes",
    "Mauriac",
    "Aurillac",
    "Vic-sur-Cère",
    "Murat",
    "Allanche",
    "Massiac",
    "Brioude",
    "Langeac",
    "Pinols",
    "Saugues",
    "Le Puy-en-Velay",
    "Yssingeaux",
    "Monistrol-sur-Loire",
    "Sainte-Sigolène",
    "Firminy",
    "Unieux",
    "Saint-Genest-Lerpt",
    "Roche-la-Molière",
    "Saint-Étienne",
    "Andrézieux-Bouthéon",
    "Montbrison",
    "Feurs",
    "Boën-sur-Lignon",
    "Noirétable",
    "Ambert",
    "Thiers",
    "Cunlhat",
    "Vertolaye",
    "Olliergues",
    "Chabreloche",
    "Courpière",
    "Lezoux",
    "Billom",
    "Riom",
    "Mozac",
    "Vichy",
    "Roanne",
    "Saint-Symphorien-de-Lay",
    "Thizy-les-Bourgs",
    "Amplepuis",
    "Tarare",
    "L'Arbresle",
    "Lozanne",
    "Chazay-d'Azergues",
    "Chatillon",
    "Villefranche-sur-Saône",
    "Gleizé",
    "Limas",
    "Arnas",
    "Belleville-en-Beaujolais",
    "Villie-Morgon",
    "Beaujeu",
    "Cours-la-Ville",
    "Chauffailles",
    "Charlieu",
    "Pouilly-sous-Charlieu",
    "Saint-Symphorien-de-Lay",
    "Vierzon",
    "Mehun-sur-Yèvre",
    "Bourges",
    "Saint-Doulchard",
    "Saint-Florent-sur-Cher",
    "Châteauroux",
    "Issoudun",
    "La Châtre",
    "Argenton-sur-Creuse",
    "Guéret",
    "Aubusson",
    "Limoges",
    "Brive-la-Gaillarde",
    "Ussel",
    "Tulle",
    "Brive",
    "Sarlat-la-Canéda",
    "Périgueux",
    "Bergerac",
    "Marmande",
    "Agen",
    "Villeneuve-sur-Lot",
    "Fumel",
    "Montauban",
    "Albi",
    "Castres",
    "Gaillac",
    "Mazamet",
    "Rodez",
    "Millau",
    "Figeac",
    "Cahors",
    "Gramat",
    "Gourdon",
    "Sarlat",
    "Les Eyzies",
    "Montignac",
    "Terrasson-Lavilledieu",
    "Brive-la-Gaillarde",
    "Objat",
    "Uzerche",
    "Tulle",
    "Laguenne",
    "Corrèze",
    "Meymac",
    "Ussel",
    "Egletons",
    "Bort-les-Orgues",
    "Neuvic",
    "Argentat-sur-Dordogne",
    "Beaulieu-sur-Dordogne",
    "Meyssac",
    "Collonges-la-Rouge",
    "Martel",
    "Souillac",
    "Gourdon",
    "Rocamadour",
    "Gramat",
    "Figeac",
    "Decazeville",
    "Villefranche-de-Rouergue",
    "Millau",
    "Saint-Affrique",
    "Lodève",
    "Clermont-l'Hérault",
    "Pézenas",
    "Agde",
    "Sète",
    "Montpellier",
    "Nîmes",
    "Alès",
    "Bagnols-sur-Cèze",
    "Pont-Saint-Esprit",
    "Orange",
    "Avignon",
    "Carpentras",
    "Apt",
    "Pertuis",
    "Manosque",
    "Digne-les-Bains",
    "Gap",
    "Embrun",
    "Briançon",
    "Sisteron",
    "Château-Arnoux-Saint-Auban",
    "Forcalquier",
    "Mane",
    "Reillanne",
    "Céreste",
    "Apt",
    "Bonnieux",
    "Gordes",
    "Roussillon",
    "Pertuis",
    "La Tour-d'Aigues",
    "Meyrargues",
    "Aix-en-Provence",
    "Salon-de-Provence",
    "Istres",
    "Miramas",
    "Martigues",
    "Port-de-Bouc",
    "Fos-sur-Mer",
    "Vitrolles",
    "Marignane",
    "Marseille",
    "Aubagne",
    "La Ciotat",
    "Cassis",
    "Toulon",
    "La Seyne-sur-Mer",
    "Hyères",
    "Draguignan",
    "Fréjus",
    "Saint-Raphaël",
    "Cannes",
    "Antibes",
    "Nice",
    "Menton",
    "Monaco",
    "Ajaccio",
    "Bastia",
    "Corte",
    "Porto-Vecchio",
    "Bonifacio",
    "Sartène",
    "Propriano",
    "Ghisonaccia",
    "Aléria",
    "Venaco",
    "Vico",
    "Calvi",
    "Île-Rousse",
    "Belgodère",
    "Bastia",
    "Biguglia",
    "Furiani",
    "Lucciana",
    "Vescovato",
    "Cervione",
    "Moriani-Plage",
    "San-Nicolao",
    "Prunete",
    "Campoloro",
    "Ghisoni",
    "Vivario",
    "Corte",
    "Venaco",
    "Castirla",
    "Sermano",
    "Piedicorte-di-Gaggio",
    "Focicchia",
    "Antisanti",
    "Altiani",
    "Aléria",
    "Ghisonaccia",
    "Solenzara",
    "Zonza",
    "Quenza",
    "Serra-di-Scopamène",
    "Santa-Lucia-di-Tallano",
    "Propriano",
    "Olmeto",
    "Sartène",
    "Bonifacio",
    "Porto-Vecchio",
    "Lecci",
    "Sainte-Lucie-de-Porto-Vecchio",
    "Figari",
    "Pianottoli-Caldarello",
    "Monacia-d'Aullène",
    "Sotta",
    "San-Gavino-di-Carbini",
    "Zonza",
    "Metz",
    "Dijon",
    "Bordeaux",
    "Strasbourg",
    "Lyon",
    "Marseille",
    "Toulouse",
    "Paris",
    "Nantes",
    "Lille",
    "Rennes",
];

// Remove duplicates while preserving order
const seen = new Set<string>();
const uniqueCities: string[] = [];
for (const city of FRENCH_CITIES) {
    if (!seen.has(city)) {
        seen.add(city);
        uniqueCities.push(city);
    }
}

export const FRENCH_CITIES_UNIQUE = uniqueCities;

// Normalize a string for comparison (remove accents, lowercase)
export function normalizeCity(str: string): string {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
}

// Smart search: returns matching cities sorted by relevance
export function searchFrenchCities(query: string, limit = 8): string[] {
    if (!query || query.trim().length === 0) return [];

    const normalizedQuery = normalizeCity(query);

    const scored: Array<{ city: string; score: number; index: number }> = [];

    for (let i = 0; i < FRENCH_CITIES_UNIQUE.length; i++) {
        const city = FRENCH_CITIES_UNIQUE[i];
        const normalizedCity = normalizeCity(city);

        if (normalizedCity.startsWith(normalizedQuery)) {
            // Highest priority: starts with the query
            scored.push({ city, score: 3, index: i });
        } else if (normalizedCity.includes(normalizedQuery)) {
            // Lower priority: contains the query
            scored.push({ city, score: 1, index: i });
        }
    }

    // Sort: higher score first, then by original index (population order)
    scored.sort((a, b) => b.score - a.score || a.index - b.index);

    return scored.slice(0, limit).map((s) => s.city);
}

export const FRENCH_REGIONS: string[] = [
    "Auvergne-Rhône-Alpes",
    "Bourgogne-Franche-Comté",
    "Bretagne",
    "Centre-Val de Loire",
    "Corse",
    "Grand Est",
    "Guadeloupe",
    "Guyane",
    "Hauts-de-France",
    "Île-de-France",
    "La Réunion",
    "Martinique",
    "Mayotte",
    "Normandie",
    "Nouvelle-Aquitaine",
    "Occitanie",
    "Pays de la Loire",
    "Provence-Alpes-Côte d'Azur",
];

export const REGION_TO_DEPARTMENTS: Record<string, string[]> = {
    "Auvergne-Rhône-Alpes":      ["01","03","07","15","26","38","42","43","63","69","73","74"],
    "Bourgogne-Franche-Comté":   ["21","25","39","58","70","71","89","90"],
    "Bretagne":                  ["22","29","35","56"],
    "Centre-Val de Loire":       ["18","28","36","37","41","45"],
    "Corse":                     ["2A","2B"],
    "Grand Est":                 ["08","10","51","52","54","55","57","67","68","88"],
    "Guadeloupe":                ["971"],
    "Guyane":                    ["973"],
    "Hauts-de-France":           ["02","59","60","62","80"],
    "Île-de-France":             ["75","77","78","91","92","93","94","95"],
    "La Réunion":                ["974"],
    "Martinique":                ["972"],
    "Mayotte":                   ["976"],
    "Normandie":                 ["14","27","50","61","76"],
    "Nouvelle-Aquitaine":        ["16","17","19","23","24","33","40","47","64","79","86","87"],
    "Occitanie":                 ["09","11","12","30","31","32","34","46","48","65","66","81","82"],
    "Pays de la Loire":          ["44","49","53","72","85"],
    "Provence-Alpes-Côte d'Azur":["04","05","06","13","83","84"],
};

/**
 * Areas people name that are not one of the 18 current regions: the pre-2016 regions plus a
 * few everyday ones ("Pays basque", "Côte d'Azur"). They have no filter of their own, so they
 * are resolved to their departments instead — "Lorraine" becomes 54 · 55 · 57 · 88.
 *
 * The AI bar's prompt lists these names (`HISTORICAL_AREAS` in `crm-back/src/controller/
 * aiFilterController.ts`); keep the two in sync, a name missing on either side just falls
 * through as unsupported. Deliberately left out: vague areas ("Sud-Ouest", "Alpes") whose
 * department list would be a guess, and names that are already a department ("Savoie").
 */
export const AREA_TO_DEPARTMENTS: Record<string, string[]> = {
    "Alsace":              ["67", "68"],
    "Antilles":            ["971", "972"],
    "Aquitaine":           ["24", "33", "40", "47", "64"],
    "Auvergne":            ["03", "15", "43", "63"],
    "Basse-Normandie":     ["14", "50", "61"],
    "Béarn":               ["64"],
    "Bourgogne":           ["21", "58", "71", "89"],
    "Centre":              ["18", "28", "36", "37", "41", "45"],
    "Champagne-Ardenne":   ["08", "10", "51", "52"],
    "Côte d'Azur":         ["06", "83"],
    "Franche-Comté":       ["25", "39", "70", "90"],
    "Haute-Normandie":     ["27", "76"],
    "Languedoc":           ["11", "30", "34", "48"],
    "Languedoc-Roussillon":["11", "30", "34", "48", "66"],
    "Limousin":            ["19", "23", "87"],
    "Lorraine":            ["54", "55", "57", "88"],
    "Midi-Pyrénées":       ["09", "12", "31", "32", "46", "65", "81", "82"],
    "Nord-Pas-de-Calais":  ["59", "62"],
    "Outre-mer":           ["971", "972", "973", "974", "976"],
    "Pays basque":         ["64"],
    "Périgord":            ["24"],
    "Picardie":            ["02", "60", "80"],
    "Poitou-Charentes":    ["16", "17", "79", "86"],
    "Provence":            ["04", "05", "13", "83", "84"],
    "Région parisienne":   ["75", "77", "78", "91", "92", "93", "94", "95"],
    "Rhône-Alpes":         ["01", "07", "26", "38", "42", "69", "73", "74"],
    "Roussillon":          ["66"],
};

export interface FrenchDepartment {
    code: string;
    name: string;
    label: string;
}

export const FRENCH_DEPARTMENTS: FrenchDepartment[] = [
    { code: "01", name: "Ain", label: "01 - Ain" },
    { code: "02", name: "Aisne", label: "02 - Aisne" },
    { code: "03", name: "Allier", label: "03 - Allier" },
    { code: "04", name: "Alpes-de-Haute-Provence", label: "04 - Alpes-de-Haute-Provence" },
    { code: "05", name: "Hautes-Alpes", label: "05 - Hautes-Alpes" },
    { code: "06", name: "Alpes-Maritimes", label: "06 - Alpes-Maritimes" },
    { code: "07", name: "Ardèche", label: "07 - Ardèche" },
    { code: "08", name: "Ardennes", label: "08 - Ardennes" },
    { code: "09", name: "Ariège", label: "09 - Ariège" },
    { code: "10", name: "Aube", label: "10 - Aube" },
    { code: "11", name: "Aude", label: "11 - Aude" },
    { code: "12", name: "Aveyron", label: "12 - Aveyron" },
    { code: "13", name: "Bouches-du-Rhône", label: "13 - Bouches-du-Rhône" },
    { code: "14", name: "Calvados", label: "14 - Calvados" },
    { code: "15", name: "Cantal", label: "15 - Cantal" },
    { code: "16", name: "Charente", label: "16 - Charente" },
    { code: "17", name: "Charente-Maritime", label: "17 - Charente-Maritime" },
    { code: "18", name: "Cher", label: "18 - Cher" },
    { code: "19", name: "Corrèze", label: "19 - Corrèze" },
    { code: "2A", name: "Corse-du-Sud", label: "2A - Corse-du-Sud" },
    { code: "2B", name: "Haute-Corse", label: "2B - Haute-Corse" },
    { code: "21", name: "Côte-d'Or", label: "21 - Côte-d'Or" },
    { code: "22", name: "Côtes-d'Armor", label: "22 - Côtes-d'Armor" },
    { code: "23", name: "Creuse", label: "23 - Creuse" },
    { code: "24", name: "Dordogne", label: "24 - Dordogne" },
    { code: "25", name: "Doubs", label: "25 - Doubs" },
    { code: "26", name: "Drôme", label: "26 - Drôme" },
    { code: "27", name: "Eure", label: "27 - Eure" },
    { code: "28", name: "Eure-et-Loir", label: "28 - Eure-et-Loir" },
    { code: "29", name: "Finistère", label: "29 - Finistère" },
    { code: "30", name: "Gard", label: "30 - Gard" },
    { code: "31", name: "Haute-Garonne", label: "31 - Haute-Garonne" },
    { code: "32", name: "Gers", label: "32 - Gers" },
    { code: "33", name: "Gironde", label: "33 - Gironde" },
    { code: "34", name: "Hérault", label: "34 - Hérault" },
    { code: "35", name: "Ille-et-Vilaine", label: "35 - Ille-et-Vilaine" },
    { code: "36", name: "Indre", label: "36 - Indre" },
    { code: "37", name: "Indre-et-Loire", label: "37 - Indre-et-Loire" },
    { code: "38", name: "Isère", label: "38 - Isère" },
    { code: "39", name: "Jura", label: "39 - Jura" },
    { code: "40", name: "Landes", label: "40 - Landes" },
    { code: "41", name: "Loir-et-Cher", label: "41 - Loir-et-Cher" },
    { code: "42", name: "Loire", label: "42 - Loire" },
    { code: "43", name: "Haute-Loire", label: "43 - Haute-Loire" },
    { code: "44", name: "Loire-Atlantique", label: "44 - Loire-Atlantique" },
    { code: "45", name: "Loiret", label: "45 - Loiret" },
    { code: "46", name: "Lot", label: "46 - Lot" },
    { code: "47", name: "Lot-et-Garonne", label: "47 - Lot-et-Garonne" },
    { code: "48", name: "Lozère", label: "48 - Lozère" },
    { code: "49", name: "Maine-et-Loire", label: "49 - Maine-et-Loire" },
    { code: "50", name: "Manche", label: "50 - Manche" },
    { code: "51", name: "Marne", label: "51 - Marne" },
    { code: "52", name: "Haute-Marne", label: "52 - Haute-Marne" },
    { code: "53", name: "Mayenne", label: "53 - Mayenne" },
    { code: "54", name: "Meurthe-et-Moselle", label: "54 - Meurthe-et-Moselle" },
    { code: "55", name: "Meuse", label: "55 - Meuse" },
    { code: "56", name: "Morbihan", label: "56 - Morbihan" },
    { code: "57", name: "Moselle", label: "57 - Moselle" },
    { code: "58", name: "Nièvre", label: "58 - Nièvre" },
    { code: "59", name: "Nord", label: "59 - Nord" },
    { code: "60", name: "Oise", label: "60 - Oise" },
    { code: "61", name: "Orne", label: "61 - Orne" },
    { code: "62", name: "Pas-de-Calais", label: "62 - Pas-de-Calais" },
    { code: "63", name: "Puy-de-Dôme", label: "63 - Puy-de-Dôme" },
    { code: "64", name: "Pyrénées-Atlantiques", label: "64 - Pyrénées-Atlantiques" },
    { code: "65", name: "Hautes-Pyrénées", label: "65 - Hautes-Pyrénées" },
    { code: "66", name: "Pyrénées-Orientales", label: "66 - Pyrénées-Orientales" },
    { code: "67", name: "Bas-Rhin", label: "67 - Bas-Rhin" },
    { code: "68", name: "Haut-Rhin", label: "68 - Haut-Rhin" },
    { code: "69", name: "Rhône", label: "69 - Rhône" },
    { code: "70", name: "Haute-Saône", label: "70 - Haute-Saône" },
    { code: "71", name: "Saône-et-Loire", label: "71 - Saône-et-Loire" },
    { code: "72", name: "Sarthe", label: "72 - Sarthe" },
    { code: "73", name: "Savoie", label: "73 - Savoie" },
    { code: "74", name: "Haute-Savoie", label: "74 - Haute-Savoie" },
    { code: "75", name: "Paris", label: "75 - Paris" },
    { code: "76", name: "Seine-Maritime", label: "76 - Seine-Maritime" },
    { code: "77", name: "Seine-et-Marne", label: "77 - Seine-et-Marne" },
    { code: "78", name: "Yvelines", label: "78 - Yvelines" },
    { code: "79", name: "Deux-Sèvres", label: "79 - Deux-Sèvres" },
    { code: "80", name: "Somme", label: "80 - Somme" },
    { code: "81", name: "Tarn", label: "81 - Tarn" },
    { code: "82", name: "Tarn-et-Garonne", label: "82 - Tarn-et-Garonne" },
    { code: "83", name: "Var", label: "83 - Var" },
    { code: "84", name: "Vaucluse", label: "84 - Vaucluse" },
    { code: "85", name: "Vendée", label: "85 - Vendée" },
    { code: "86", name: "Vienne", label: "86 - Vienne" },
    { code: "87", name: "Haute-Vienne", label: "87 - Haute-Vienne" },
    { code: "88", name: "Vosges", label: "88 - Vosges" },
    { code: "89", name: "Yonne", label: "89 - Yonne" },
    { code: "90", name: "Territoire de Belfort", label: "90 - Territoire de Belfort" },
    { code: "91", name: "Essonne", label: "91 - Essonne" },
    { code: "92", name: "Hauts-de-Seine", label: "92 - Hauts-de-Seine" },
    { code: "93", name: "Seine-Saint-Denis", label: "93 - Seine-Saint-Denis" },
    { code: "94", name: "Val-de-Marne", label: "94 - Val-de-Marne" },
    { code: "95", name: "Val-d'Oise", label: "95 - Val-d'Oise" },
    { code: "971", name: "Guadeloupe", label: "971 - Guadeloupe" },
    { code: "972", name: "Martinique", label: "972 - Martinique" },
    { code: "973", name: "Guyane", label: "973 - Guyane" },
    { code: "974", name: "La Réunion", label: "974 - La Réunion" },
    { code: "976", name: "Mayotte", label: "976 - Mayotte" },
];

export function searchDepartments(query: string, limit = 8): FrenchDepartment[] {
    if (!query) return FRENCH_DEPARTMENTS.slice(0, limit);
    const q = query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return FRENCH_DEPARTMENTS.filter(d => {
        const normalName = d.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return d.code.toLowerCase().startsWith(q) || normalName.includes(q);
    }).slice(0, limit);
}

// Inverted once from REGION_TO_DEPARTMENTS: departement code -> region name, for display
// (e.g. news cards showing "Paris (75, Ile-de-France)").
const DEPARTMENT_TO_REGION: Record<string, string> = Object.fromEntries(
    Object.entries(REGION_TO_DEPARTMENTS).flatMap(([region, codes]) => codes.map((code) => [code, region]))
);

/**
 * "Paris (75, Ile-de-France)" from a city name and its departement code. Falls back to the
 * bare city name when the code is missing or unknown (e.g. news articles whose city hasn't
 * been matched against `cityData` yet).
 */
export function formatCityWithLocation(city: string, departmentCode: string | null | undefined): string {
    if (!departmentCode) return city;
    const region = DEPARTMENT_TO_REGION[departmentCode];
    return region ? `${city} (${departmentCode}, ${region})` : `${city} (${departmentCode})`;
}
